<div>
  <span class="flex">
      <label class="mb-1 block font-medium {{!readonly && required ? requiredClasses : ''}}" *ngIf="label"
             [ngClass]="{ disabled: isDisabled }">{{ label }}</label>
      <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                     [sizeInPx]="infoIconSize"></psc-info-icon>
  </span>

  <psc-readonly-value
    *ngIf="readonly; else notReadonly"
    [value]="value">
  </psc-readonly-value>

  <ng-template #notReadonly>
    <div class="flex" *transloco="let t">
      <textarea
        class="{{inputClasses}}"
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
        placeholder="{{ placeholder || t('placeholders.text_input') }}"
        [cols]="cols"
        [rows]="rows"
        [disabled]="isDisabled"></textarea>
    </div>
  </ng-template>

  <psc-input-error
    [control]="formControl"
    [format]="format"></psc-input-error>
</div>
